var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item"},[_c('span',{staticClass:"nav-link",class:[_vm.status !== 'valid' ? 'has-error' : '']},[_c('a-icon',{class:_vm.icon.iconClass,staticStyle:{"width":"24px","height":"24px"},attrs:{"icon":_vm.icon.icon}}),_c('span',[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }